import "./TablePlans.scss";

import moment from "moment";
import { Link } from "react-router-dom";
import { FlagIcon } from "react-flag-kit";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import MenuItem from "@material-ui/core/MenuItem";
import LinearProgress from "@material-ui/core/LinearProgress";

import PlaceholderText from "../Placeholder/PlaceholderText";
import infinite from "../../assets/images/flag_multilingo.png";
import { MomentHelpers } from "../MomentLocalDate/MomentLocalDate";
import Schedule from "../../assets/images/icons/icon_bt_schedule.svg";

function TablePlans() {
  const { t, i18n } = useTranslation();
  const { plans } = useSelector((state) => state.studentReducer);

  const calculatePlanEndDate = (plan) => {
    if (plan.studentPlanPayments && plan.studentPlanPayments.length > 0) {
      return MomentHelpers.formatHelper(plan.studentPlanPayments[0].providerNextCycleDate, i18n.language);
    } else if (
      plan.student &&
      plan.student.contractPlanStudents &&
      plan.student.contractPlanStudents[0] &&
      plan.student.contractPlanStudents[0].studentPlanB2BRenewalCycle &&
      plan.student.contractPlanStudents[0].studentPlanB2BRenewalCycle.nextCyc
    ) {
      return MomentHelpers.formatHelper(
        moment(plan.student.contractPlanStudents[0].studentPlanB2BRenewalCycle.nextCyc).utc(),
        i18n.language,
      );
    } else {
      let monthDiff = moment().diff(plan.createdAt, "month") + 1;
      return MomentHelpers.formatHelper(moment(plan.createdAt).add(monthDiff, "M"), i18n.language);
    }
  };

  let newUserPlans = [];
  var hasMultilingo = false;
  for (var item in plans) {
    if (plans[item].multiLingo) {
      if (!hasMultilingo) {
        newUserPlans.push(plans[item]);
        hasMultilingo = true;
      }
    } else newUserPlans.push(plans[item]);
  }

  const languageLevel =
    plans &&
    plans[0]?.studentPlanLanguages?.map((lang) => {
      const associatedLevel = plans[0].student.studentLevelGrades.find(
        (lvl) => lvl.lingoLanguageId === lang.lingoLanguageId,
      );
      return { level: associatedLevel ? associatedLevel.level.level : "-" };
    });

  return (
    <div className="container">
      {!plans?.length ? (
        <PlaceholderText />
      ) : (
        <>
          {plans.map((plan, index) => (
            <div className="bigBox" key={JSON.stringify(plan)}>
              <div className="boxItem">
                <div className="item">
                  <div className="itensBox ml15">
                    <h3>{t("CARD_PLAN")}</h3>
                    <span>{plan.plan.nameEnglish}</span>
                  </div>
                  <div className="itensBox">
                    <h3>{t("CARD_PLAN_COURSE")}</h3>
                    <span>
                      {plan.plan.multiLingo === false && plan.studentPlanLanguages.length < 2 && (
                        <div>
                          <MenuItem value={plan.id}>
                            <FlagIcon
                              code={
                                plan.studentPlanLanguages[0].lingoLanguage.customLang
                                  ? plan.studentPlanLanguages[0].lingoLanguage.flag.split("-")[1]
                                  : plan.studentPlanLanguages[0].lingoLanguage.flag
                              }
                            />
                            {t(plan.studentPlanLanguages[0].lingoLanguage.description.toUpperCase())}
                          </MenuItem>
                        </div>
                      )}

                      {(plan.plan.multiLingo === true || plan.studentPlanLanguages.length > 2) && (
                        <div className="multilingo studentPlansLevels">
                          {plan.studentPlanLanguages.map((language, i) => (
                            <div key={i}>
                              <FlagIcon key={i} code={language.lingoLanguage.flag} />
                              <span>{languageLevel[i]?.level}</span>
                            </div>
                          ))}
                        </div>
                      )}
                    </span>
                  </div>
                  {plan.plan.multiLingo === false && plan.studentPlanLanguages.length < 2 && (
                    <div className="itensBox">
                      <h3>{t("CARD_PLAN_LEVEL")}</h3>
                      <span>
                        {plan.student.studentLevelGrades.length > 0
                          ? plan.student.studentLevelGrades?.map((item) => item?.level?.level).join(", ")
                          : "-"}
                      </span>
                    </div>
                  )}
                  <div className="itensBox">
                    <h3>{t("CARD_PLAN_SCHEDULE")}</h3>
                    <span>
                      {!plan.plan.trial ? t("RESETS_ON") : t("EXPIRED_ON")} {calculatePlanEndDate(plan)}
                    </span>
                  </div>
                  {plan.plan.unlimited === false ? (
                    <div className="itensBox percentage">
                      <h3>
                        {plan?.availableClasses <= 0
                          ? "100"
                          : parseFloat((plan?.availableClasses / plan?.plan?.totalClasses) * 100) % 1 !== 0
                          ? parseFloat(100 - (plan?.availableClasses / plan?.plan?.totalClasses) * 100).toFixed(2)
                          : parseFloat(100 - (plan?.availableClasses / plan?.plan?.totalClasses) * 100)}
                        %
                      </h3>
                      <span>
                        {plan?.plan?.totalClasses - plan?.availableClasses > plan?.plan?.totalClasses
                          ? plan?.plan?.totalClasses
                          : plan?.plan?.totalClasses - plan.availableClasses}{" "}
                        / {plan?.plan?.totalClasses} {t("CARD_PLAN_CLASS")}
                      </span>
                    </div>
                  ) : (
                    <div className="itensBox percentage">
                      <h3>
                        <img style={{ width: "48px" }} src={infinite} alt="multilingo" />
                      </h3>
                    </div>
                  )}
                  <div className="divButtons mr15">
                    <div className="itensBoxButtons">
                      <Link to={`/manage-account/plan`}>
                        <button>
                          {t("BTN_VIEW")} <i className="fa fa-angle-right" aria-hidden="true" />
                        </button>
                      </Link>
                      {plans[index]?.student?.classToolId?.includes("http://") ||
                      plans[index]?.student?.classToolId?.includes("https://") ? (
                        <a
                          className="linkClassRoom"
                          href={plans[index].student.classToolId}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img src={Schedule} alt="View Schedule" />
                          {t("CLASS_LINK")}
                        </a>
                      ) : (
                        <span className="userSkype">Skype: {plans[index]?.student?.classToolId}</span>
                      )}
                    </div>
                    {plan.availablePartClasses > 0 && (
                      <div className="extraClassLabel">
                        <span>
                          <b>{plan.availablePartClasses}</b> <b>{t("EXTRA_CLASSES")}</b> {t("IN_STOCK")}.
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {plan.plan.multiLingo === false && (
                <div className={plan.root}>
                  <LinearProgress
                    color="primary"
                    variant="determinate"
                    value={
                      plan?.availableClasses <= 0
                        ? 100
                        : parseFloat((plan?.availableClasses / plan?.plan?.totalClasses) * 100) % 1 !== 0
                        ? parseFloat(100 - (plan?.availableClasses / plan?.plan?.totalClasses) * 100).toFixed(2)
                        : parseFloat(100 - (plan?.availableClasses / plan?.plan?.totalClasses) * 100)
                    }
                  />
                </div>
              )}
              {plan.plan.multiLingo === true && (
                <div className={plan.root}>
                  <LinearProgress
                    color="primary"
                    variant="determinate"
                    value={
                      plan?.availableClasses <= 0
                        ? 100
                        : parseFloat((plan?.availableClasses / plan?.plan?.totalClasses) * 100) % 1 !== 0
                        ? parseFloat(100 - (plan?.availableClasses / plan?.plan?.totalClasses) * 100).toFixed(2)
                        : parseFloat(100 - (plan?.availableClasses / plan?.plan?.totalClasses) * 100)
                    }
                  />
                </div>
              )}
              {plans?.length === 1 && plan.plan.trial && (
                <div>
                  <Link to="/manage-account/plan?type=buynewplan">
                    <button style={{ backgroundColor: "red" }}>{t("BTN_BUY_PLAN")}</button>
                  </Link>
                </div>
              )}
            </div>
          ))}
        </>
      )}
    </div>
  );
}

export default TablePlans;
